import { styled, keyframes } from '@mui/material';

export const BookingsFiltersSelectOption = styled('div')({
  display: 'flex',
  gap: 10,
});

export const BookingsFiltersWrapper = styled('div')({
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'space-between',
  paddingRight: 16,
  marginTop: 16,
  flexWrap: 'wrap',
  rowGap: 16,
});

export const swingAnimationKeyframes = keyframes`
 to {
    opacity:1
  }
`;

interface BookingStatusRoundProps {
  bgColor: string;
  index?: number;
}

export const BookingStatusRound = styled('div')<BookingStatusRoundProps>(
  ({ bgColor, index = 0 }) => ({
    borderRadius: '50%',
    width: '10px',
    height: '10px',
    backgroundColor: bgColor,
    opacity: 0,
    animation: `${swingAnimationKeyframes} 1s ${index * 0.2}s forwards`,
    marginLeft:'auto'
  }),
);
